module.exports = __webpack_public_path__ + "static/media/callout-background.89c2a2bb.svg";